/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/DebouncedModel.js");

module.exports = Model({
	name: "myreminders",
	init: init,
	listeners: listeners,
});

function init() {
	this.push({
		ownreminders: {},
		ownreminderhistory: [],
		ownpendingreminders: [],
		ownactivereminder: {}
	});
}

function listeners() {
	return {
		"ownreminders:updated": Model.makeExtender("ownreminders"),
		"ownremindermaker:updated": Model.makeExtender("reminder_maker"),
		"ownreminderhistory:updated": Model.makeExtender("ownreminderhistory"),
		"ownpendingreminders:updated": Model.makeExtender("ownpendingreminders"),
	};
}
